/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IModule } from "../../models/Organizations/Application";
import { GET_ALL_MODULES, SET_AVAILABLE_MODULES, SET_FILTERED_MODULES, SET_NO_MODULE, SET_SELECTED_MODULE, RESET_MODULES } from "./types";

export const getAllModuleAction = (modules: any, selectedModule: any, pagination: any, noModule: boolean) => {
  return {
    type: GET_ALL_MODULES,
    modules,
    selectedModule,
    pagination,
    noModule,
  };
};

export const setSelectedModuleAction = (selectedModule: IModule) => {
  return {
    type: SET_SELECTED_MODULE,
    selectedModule,
  };
};

export const setNoModuleAction = (noModule: boolean) => {
  return {
    type: SET_NO_MODULE,
    noModule,
  };
};

export const setAvailableModulesList = (availableModules: any) => {
  return {
    type: SET_AVAILABLE_MODULES,
    availableModules,
  };
}

export const setFilteredModuleAction = (filteredModules: IModule[]) => {
  return {
    type: SET_FILTERED_MODULES,
    filteredModules,
  };
};

export const resetModulesAction = () => {
  return {
    type: RESET_MODULES,
    modules: [],
    selectedModule: {},
    noModule: false,
  };
}